/* File is generated by pnpm codegen */

import { FCM_DETAILS_ADVOCATES_PSF } from './details/advocates_psf';
import { FCM_DETAILS_ADVOCATES_PSF_END_REDIRECT } from './details/advocates_psf_end_redirect';
import { FCM_DETAILS_ADVOCATES_PSF_TASKS } from './details/advocates_psf_tasks';
import { FCM_DETAILS_AI_SHARE_HEADLINE_BANDIT } from './details/ai_share_headline_bandit';
import { FCM_DETAILS_ALLOW_IDENTIFIED_USER_FETCH_PETITION_LISTS } from './details/allow_identified_user_fetch_petition_lists';
import { FCM_DETAILS_AMPLITUDE_SESSION_REPLAY_CONFIG } from './details/amplitude_session_replay_config';
import { FCM_DETAILS_AUTO_FREE_PROMOTIONS_ROLLOUT } from './details/auto_free_promotions_rollout';
import { FCM_DETAILS_BETA_LOCALES_ENABLED } from './details/beta_locales_enabled';
import { FCM_DETAILS_BLOCKED_SIGNATURE_EXPORT } from './details/blocked_signature_export';
import { FCM_DETAILS_CAMPAIGN_ACTIONS_PAGE_CONFIG } from './details/campaign_actions_page_config';
import { FCM_DETAILS_CAMPAIGN_SUPPORTER_VOICES_SETTINGS } from './details/campaign_supporter_voices_settings';
import { FCM_DETAILS_CAPYBARA_HOMEPAGE_V3 } from './details/capybara_homepage_v3';
import { FCM_DETAILS_CAPYBARA_IMPACT_STORY } from './details/capybara_impact_story';
import { FCM_DETAILS_CAROUSEL_CONFIGURATION } from './details/carousel_configuration';
import { FCM_DETAILS_CAROUSEL_MEMBERSHIP_CONFIGURATION } from './details/carousel_membership_configuration';
import { FCM_DETAILS_COFFEE_GEO_PROFILE_QUALITY } from './details/coffee_geo_profile_quality';
import { FCM_DETAILS_COMBO_PROMOTER_CONTRIBUTION_IMPACT_VALUES } from './details/combo_promoter_contribution_impact_values';
import { FCM_DETAILS_COMMS_STACK_DM_ADDED_ENGAGEMENT_VALUE_PROPS_ENABLED } from './details/comms_stack_dm_added_engagement_value_props_enabled';
import { FCM_DETAILS_COMMS_STACK_PETITION_SIGNER_REENGAGEMENT_RECOMMENDATIONS_ENABLED } from './details/comms_stack_petition_signer_reengagement_recommendations_enabled';
import { FCM_DETAILS_COMMS_STACK_SUBJECT_LINE_EXPERIMENTATION_ENABLED } from './details/comms_stack_subject_line_experimentation_enabled';
import { FCM_DETAILS_COMMS_STACK_TEMPLATE_EXPERIMENTATION_ENABLED } from './details/comms_stack_template_experimentation_enabled';
import { FCM_DETAILS_CONTEXTUAL_PROMOTION_BUTTONS_BANDIT_CONFIG } from './details/contextual_promotion_buttons_bandit_config';
import { FCM_DETAILS_CORAL_COMMENT_LIKE_EMAIL_ENABLED } from './details/coral_comment_like_email_enabled';
import { FCM_DETAILS_CORGI_ALLOW_IFRAME_EMBEDDING } from './details/corgi_allow_iframe_embedding';
import { FCM_DETAILS_CORGI_OAUTH_MIGRATION_CONFIG } from './details/corgi_oauth_migration_config';
import { FCM_DETAILS_CORGI_PERIMETERX_SENSOR_SCRIPT_ENABLED } from './details/corgi_perimeterx_sensor_script_enabled';
import { FCM_DETAILS_CORGI_REQUEST_PROVIDER_LOGGING_CONFIG } from './details/corgi_request_provider_logging_config';
import { FCM_DETAILS_CORGI_SSR_CACHE } from './details/corgi_ssr_cache';
import { FCM_DETAILS_CORGI_SSR_CACHE_BUSTER } from './details/corgi_ssr_cache_buster';
import { FCM_DETAILS_CORGI_SSR_CACHE_LIFETIME_SECONDS_OVERRIDE } from './details/corgi_ssr_cache_lifetime_seconds_override';
import { FCM_DETAILS_CORGI_SSR_TIMINGS_RESPONSE_HEADER } from './details/corgi_ssr_timings_response_header';
import { FCM_DETAILS_CORGI_USE_ASSETS_DOMAIN_FOR_SCRIPTS } from './details/corgi_use_assets_domain_for_scripts';
import { FCM_DETAILS_COUNTRY_BANNER } from './details/country_banner';
import { FCM_DETAILS_CREAM_CHIP_IN_VALUES } from './details/cream_chip_in_values';
import { FCM_DETAILS_CREAM_PETITION_UPDATE_PROMOTION_ASK } from './details/cream_petition_update_promotion_ask';
import { FCM_DETAILS_DATA_DISABLE_PETSVC_SALESFORCE_WORKER } from './details/data_disable_petsvc_salesforce_worker';
import { FCM_DETAILS_DECISION_MAKERS_AUTOADD_ENABLED } from './details/decision_makers_autoadd_enabled';
import { FCM_DETAILS_DECISION_MAKERS_LEGISLATIVE_BODIES } from './details/decision_makers_legislative_bodies';
import { FCM_DETAILS_DISABLE_ADMIN_LOGIN } from './details/disable_admin_login';
import { FCM_DETAILS_DISABLE_GEOLOCATION_GUEST_SIGN_FORM } from './details/disable_geolocation_guest_sign_form';
import { FCM_DETAILS_DM_ABOUT_PAGE } from './details/dm_about_page';
import { FCM_DETAILS_DM_PROFILE_REDESIGN } from './details/dm_profile_redesign';
import { FCM_DETAILS_DM_PROFILE_RESPONSIVENESS_SCORE_CONFIG } from './details/dm_profile_responsiveness_score_config';
import { FCM_DETAILS_DM_PROFILE_RESPONSIVENESS_SCORE_DATA } from './details/dm_profile_responsiveness_score_data';
import { FCM_DETAILS_DM_WITH_LEGISLATIVE_BODIES_CONNECTION_ENABLED } from './details/dm_with_legislative_bodies_connection_enabled';
import { FCM_DETAILS_DMI_SERVICE_AUTO_TRIGGER_ENABLED } from './details/dmi_service_auto_trigger_enabled';
import { FCM_DETAILS_DOUBLE_OPT_IN_ENABLED } from './details/double_opt_in_enabled';
import { FCM_DETAILS_DOUBLE_OPT_IN_PETITION_LIST } from './details/double_opt_in_petition_list';
import { FCM_DETAILS_DOUBLE_OPTIN_ENABLED_NEW_USER } from './details/double_optin_enabled_new_user';
import { FCM_DETAILS_ENABLE_ADVOCATES_IDENTIFIED_EXPERIMENT } from './details/enable_advocates_identified_experiment';
import { FCM_DETAILS_ENABLE_BLACK_HISTORY_LOGO } from './details/enable_black_history_logo';
import { FCM_DETAILS_ENABLE_FOLKSONOMY_TOPICS } from './details/enable_folksonomy_topics';
import { FCM_DETAILS_ENABLE_PETITION_STRENGTH_TIPS } from './details/enable_petition_strength_tips';
import { FCM_DETAILS_ENABLE_PRIDE_LOGO } from './details/enable_pride_logo';
import { FCM_DETAILS_ENABLE_SUBSCRIPTIONS_FOR } from './details/enable_subscriptions_for';
import { FCM_DETAILS_ENABLE_VISION_FE_HELLOWORLD } from './details/enable_vision_fe_helloworld';
import { FCM_DETAILS_ENFORCE_SECURE_IDENTIFIED_STATE } from './details/enforce_secure_identified_state';
import { FCM_DETAILS_ENGAGEMENT_SIGN_FORM_MOBILE_OPT_IN_CONFIG } from './details/engagement_sign_form_mobile_opt_in_config';
import { FCM_DETAILS_EXPORT_SERVICE } from './details/export_service';
import { FCM_DETAILS_EXPORT_SIGNATURE_BLOCKLIST } from './details/export_signature_blocklist';
import { FCM_DETAILS_FUTURE_SAP_MARKETING_CONSENT_REQUIRED } from './details/future_sap_marketing_consent_required';
import { FCM_DETAILS_FUTURE_SAP_MEDIA_DISCLAIMER } from './details/future_sap_media_disclaimer';
import { FCM_DETAILS_GATEWAY_ROUTER_STRIPE_CREATE_CHARGE_CONFIG } from './details/gateway_router_stripe_create_charge_config';
import { FCM_DETAILS_GATEWAY_ROUTER_STRIPE_CREATE_OR_UPDATE_CUSTOMER_CONFIG } from './details/gateway_router_stripe_create_or_update_customer_config';
import { FCM_DETAILS_GDPR_SIGN_OPT_IN } from './details/gdpr_sign_opt_in';
import { FCM_DETAILS_GDPR_SIGN_OPT_IN_COPY } from './details/gdpr_sign_opt_in_copy';
import { FCM_DETAILS_GLOBAL_SHARE_BUTTON_CONFIG } from './details/global_share_button_config';
import { FCM_DETAILS_GOOGLE_AUTH } from './details/google_auth';
import { FCM_DETAILS_GOOGLE_AUTH_USE_IDENTITY_SERVICES } from './details/google_auth_use_identity_services';
import { FCM_DETAILS_GRAPHQL_RESOLVER_TRACING } from './details/graphql_resolver_tracing';
import { FCM_DETAILS_GROWTH_BONUS_IMPRESSION_VALUE_UI } from './details/growth_bonus_impression_value_ui';
import { FCM_DETAILS_GROWTH_IS_STARTER } from './details/growth_is_starter';
import { FCM_DETAILS_GROWTH_LEGAL_DISCLAIMER_UPDATE } from './details/growth_legal_disclaimer_update';
import { FCM_DETAILS_GROWTH_MEMBERSHIP_ROUTING_UPDATE } from './details/growth_membership_routing_update';
import { FCM_DETAILS_GROWTH_MEMBERSHIP_UI_UPDATE } from './details/growth_membership_ui_update';
import { FCM_DETAILS_HIDE_NAV_SAP_BUTTON_PER_PAGE } from './details/hide_nav_sap_button_per_page';
import { FCM_DETAILS_HIDE_SIGNEES } from './details/hide_signees';
import { FCM_DETAILS_HIGH_AMOUNT_CONFIRMATION_MODAL } from './details/high_amount_confirmation_modal';
import { FCM_DETAILS_HOMEPAGE_NOTICE } from './details/homepage_notice';
import { FCM_DETAILS_HOMEPAGE_SUPPORT_AWARENESS } from './details/homepage_support_awareness';
import { FCM_DETAILS_LCM_PETITION_SIGNER_RECEIPT_WELCOME_CONFIG } from './details/lcm_petition_signer_receipt_welcome_config';
import { FCM_DETAILS_MAINTENANCE_BANNER } from './details/maintenance_banner';
import { FCM_DETAILS_MANUALLY_PROMOTED_PETITION_DATA } from './details/manually_promoted_petition_data';
import { FCM_DETAILS_MEMBER_PHONE_COLLECTION } from './details/member_phone_collection';
import { FCM_DETAILS_MEMBERSHIP_ANNUAL_CONTRIBUTION } from './details/membership_annual_contribution';
import { FCM_DETAILS_MEMBERSHIP_BOTTOM_BANNER_ENABLED_FOR } from './details/membership_bottom_banner_enabled_for';
import { FCM_DETAILS_MEMBERSHIP_CONTACT_EMAIL } from './details/membership_contact_email';
import { FCM_DETAILS_MEMBERSHIP_PPMU_ENABLED_FOR } from './details/membership_ppmu_enabled_for';
import { FCM_DETAILS_MEMBERSHIP_PPMU_OFFSITE_COPY } from './details/membership_ppmu_offsite_copy';
import { FCM_DETAILS_MEMBERSHIP_PPMU_OFFSITE_LINK } from './details/membership_ppmu_offsite_link';
import { FCM_DETAILS_MIDDLE_END_RESTRICT_CLIENTS } from './details/middle_end_restrict_clients';
import { FCM_DETAILS_MOBILE_APP_DOWNLOAD_BOTTOM_BANNER_ENABLED } from './details/mobile_app_download_bottom_banner_enabled';
import { FCM_DETAILS_MOBILE_APP_RELEASES } from './details/mobile_app_releases';
import { FCM_DETAILS_MOBILE_APP_SMART_BANNER_CONFIG } from './details/mobile_app_smart_banner_config';
import { FCM_DETAILS_MOBILE_NOTIFICATIONS_CONFIG } from './details/mobile_notifications_config';
import { FCM_DETAILS_MONETIZATION_BANDIT_COMBO_EXP } from './details/monetization_bandit_combo_exp';
import { FCM_DETAILS_MOVEMENT_PETITION_ADD_NOTIFICATION } from './details/movement_petition_add_notification';
import { FCM_DETAILS_NAFTA_PSF_SHARE_COPY_BANDIT_TRAFFIC_CONFIG } from './details/nafta_psf_share_copy_bandit_traffic_config';
import { FCM_DETAILS_NEW_PETITION_PAGE_ACCESS_EXPERIMENT } from './details/new_petition_page_access_experiment';
import { FCM_DETAILS_NEW_PETITION_PAGE_GOOGLE_ADDRESS_EXPERIMENT } from './details/new_petition_page_google_address_experiment';
import { FCM_DETAILS_NEW_PETITION_PAGE_REMOVE_RFS_EXPERIMENT } from './details/new_petition_page_remove_rfs_experiment';
import { FCM_DETAILS_NEWRELIC_BROWSER_ENABLED } from './details/newrelic_browser_enabled';
import { FCM_DETAILS_OCTOPUS_AA_AUGMENTED_SIGN_ASK_CONFIG } from './details/octopus_aa_augmented_sign_ask_config';
import { FCM_DETAILS_OCTOPUS_AA_SIGN_ASK_CONFIG } from './details/octopus_aa_sign_ask_config';
import { FCM_DETAILS_OCTOPUS_AUTO_AA_ML_DIGEST_CONFIG } from './details/octopus_auto_aa_ml_digest_config';
import { FCM_DETAILS_OCTOPUS_AUTO_AA_ML_DIGEST_NEW_ONBOARDING_CONFIG } from './details/octopus_auto_aa_ml_digest_new_onboarding_config';
import { FCM_DETAILS_OCTOPUS_AUTO_AA_ML_SINGLE_CONFIG } from './details/octopus_auto_aa_ml_single_config';
import { FCM_DETAILS_OCTOPUS_PETITION_SIGNER_RECEIPT_CONFIG } from './details/octopus_petition_signer_receipt_config';
import { FCM_DETAILS_OCTOPUS_PETITION_UPDATE_CONFIG } from './details/octopus_petition_update_config';
import { FCM_DETAILS_OCTOPUS_TAKO_EDITOR_CONFIG } from './details/octopus_tako_editor_config';
import { FCM_DETAILS_OPTIMIZELY_ENABLED } from './details/optimizely_enabled';
import { FCM_DETAILS_OPTIMIZELY_EVENT_SAFELIST } from './details/optimizely_event_safelist';
import { FCM_DETAILS_OPTIMIZELY_PAGES } from './details/optimizely_pages';
import { FCM_DETAILS_OPTIMIZELY_PROPERTY_SAFELIST } from './details/optimizely_property_safelist';
import { FCM_DETAILS_PACIFIC_DISABLE_COMMS_AA_EDITORIAL_RECENT_STARTER_SUPRESSION } from './details/pacific_disable_comms_aa_editorial_recent_starter_supression';
import { FCM_DETAILS_PACIFIC_PETITION_PROMOTION_CONFIG } from './details/pacific_petition_promotion_config';
import { FCM_DETAILS_PACIFIC_PROMO_FREE_SAMPLE } from './details/pacific_promo_free_sample';
import { FCM_DETAILS_PAYMENT_METHODS_ENABLED_FOR } from './details/payment_methods_enabled_for';
import { FCM_DETAILS_PAYMENTS_SAVE_PAYMENT_CHECKMARK_CONFIG } from './details/payments_save_payment_checkmark_config';
import { FCM_DETAILS_PAYPAL_MOBILE_DEFAULT } from './details/paypal_mobile_default';
import { FCM_DETAILS_PETITION_PAGE_CONTACT_DM } from './details/petition_page_contact_dm';
import { FCM_DETAILS_PETITION_PAGE_DM_CONSTITUENCY_CONFIG } from './details/petition_page_dm_constituency_config';
import { FCM_DETAILS_PETITION_PAGE_FULL_SUNRISE } from './details/petition_page_full_sunrise';
import { FCM_DETAILS_PETITION_PAGE_NEWLY_CREATED_PETITIONS } from './details/petition_page_newly_created_petitions';
import { FCM_DETAILS_PETITION_PROMOTE_PAGE_FOR_COUNTRY } from './details/petition_promote_page_for_country';
import { FCM_DETAILS_PETITION_STARTER_MEDIA_INQUIRY } from './details/petition_starter_media_inquiry';
import { FCM_DETAILS_PETITION_UPDATE_EMAIL_PREVIEW_ENABLED } from './details/petition_update_email_preview_enabled';
import { FCM_DETAILS_PETITIONS_WITH_BLOCKED_SIGNATURE_EXPORT } from './details/petitions_with_blocked_signature_export';
import { FCM_DETAILS_PLATFORM_FRAUD_EMAIL_DOMAINS } from './details/platform_fraud_email_domains';
import { FCM_DETAILS_PRIVACY_ANONYMOUS_USERS } from './details/privacy_anonymous_users';
import { FCM_DETAILS_PRIVACY_HIDE_RECRUITER } from './details/privacy_hide_recruiter';
import { FCM_DETAILS_PROMOTE_FORM_LAYOUT_EXPERIMENT } from './details/promote_form_layout_experiment';
import { FCM_DETAILS_PROMOTED_FULFILLMENT_BY_CHANNEL } from './details/promoted_fulfillment_by_channel';
import { FCM_DETAILS_PROMOTED_PETITION_SIGNER_RECEIPT_DIGEST_EMAIL_PROMOTION_COUNT } from './details/promoted_petition_signer_receipt_digest_email_promotion_count';
import { FCM_DETAILS_PROMOTED_PETITION_SIGNER_RECEIPT_WELCOME_EMAIL_PROMOTION_COUNT } from './details/promoted_petition_signer_receipt_welcome_email_promotion_count';
import { FCM_DETAILS_PROMOTED_PETITION_UPDATE_EMAIL_PROMOTION_SETTINGS } from './details/promoted_petition_update_email_promotion_settings';
import { FCM_DETAILS_PROMOTED_PETITIONS_DISABLE_USER_SIGNATURE_FETCH } from './details/promoted_petitions_disable_user_signature_fetch';
import { FCM_DETAILS_PROMOTED_PETITIONS_IN_FOOTER_WELL } from './details/promoted_petitions_in_footer_well';
import { FCM_DETAILS_PROMOTED_PETITIONS_USE_UNFILTERED_LIST } from './details/promoted_petitions_use_unfiltered_list';
import { FCM_DETAILS_PROMOTED_SIGNATURE_RECEIPT_EMAIL_PROMOTION_COUNT } from './details/promoted_signature_receipt_email_promotion_count';
import { FCM_DETAILS_PROMOTION_COUNTRY_GRADUAL_OPENING } from './details/promotion_country_gradual_opening';
import { FCM_DETAILS_PROMOTIONS_ENDPOINT_CACHE_PETITION_STATS } from './details/promotions_endpoint_cache_petition_stats';
import { FCM_DETAILS_PROMOTIONS_INELIGIBLE_PETITION_REFUND_LIMIT } from './details/promotions_ineligible_petition_refund_limit';
import { FCM_DETAILS_PROMOTIONS_INELIGIBLE_PETITION_REFUNDS_ENABLED } from './details/promotions_ineligible_petition_refunds_enabled';
import { FCM_DETAILS_PROMOTIONS_SHOW_ALL_PROMOTIONS_AT_START_OF_CAROUSEL } from './details/promotions_show_all_promotions_at_start_of_carousel';
import { FCM_DETAILS_PSF_CONTEXTUAL_BANDITS_ENABLED } from './details/psf_contextual_bandits_enabled';
import { FCM_DETAILS_PSF_PROMOTE_OR_SHARE_SHARE_SLIDE_UP_ENABLED } from './details/psf_promote_or_share_share_slide_up_enabled';
import { FCM_DETAILS_PSF_REASON_FOR_SIGNING } from './details/psf_reason_for_signing';
import { FCM_DETAILS_PSF_SHARE_BUTTON_CONFIG } from './details/psf_share_button_config';
import { FCM_DETAILS_PSF_SHARE_INITIAL_ABOVE_BUTTON_MESSAGE } from './details/psf_share_initial_above_button_message';
import { FCM_DETAILS_PSF_SHARE_MESSAGE_BUTTON_ORDER } from './details/psf_share_message_button_order';
import { FCM_DETAILS_REGISTERED_VOTERS_CONFIG } from './details/registered_voters_config';
import { FCM_DETAILS_REVENUE_BANDITS_PSF_COMBO_EXPERIMENT } from './details/revenue_bandits_psf_combo_experiment';
import { FCM_DETAILS_REVENUE_DYNAMIC_CPM } from './details/revenue_dynamic_cpm';
import { FCM_DETAILS_REVENUE_LOCALIZED_MEMBERSHIP_ASK_HEADLINE } from './details/revenue_localized_membership_ask_headline';
import { FCM_DETAILS_REVENUE_PETITION_AI_SUMMARIES_COMBO_EXPERIMENT } from './details/revenue_petition_ai_summaries_combo_experiment';
import { FCM_DETAILS_REVENUE_PETITION_AI_SUMMARIES_ENABLED } from './details/revenue_petition_ai_summaries_enabled';
import { FCM_DETAILS_REVENUE_PPMU_SUNRISE_DOUBLE_HOLDOUT_EXPERIMENT } from './details/revenue_ppmu_sunrise_double_holdout_experiment';
import { FCM_DETAILS_REVENUE_SUBS_ONE_TIME_CONTRIBUTIONS } from './details/revenue_subs_one_time_contributions';
import { FCM_DETAILS_REVENUE_VICTORIOUS_PETITION_PROMOTION_ENABLED } from './details/revenue_victorious_petition_promotion_enabled';
import { FCM_DETAILS_SAP_AI_IMAGE_PROMPT } from './details/sap_ai_image_prompt';
import { FCM_DETAILS_SAP_CTA_ON_PETITION_SHOW } from './details/sap_cta_on_petition_show';
import { FCM_DETAILS_SEARCH_V2_MAINTENANCE } from './details/search_v2_maintenance';
import { FCM_DETAILS_SHOW_SAVE_PAYMENT_CHECKBOX_CONFIG } from './details/show_save_payment_checkbox_config';
import { FCM_DETAILS_SIGN_CONFIRM_USE_MONORAIL_SOA_ENDPOINT } from './details/sign_confirm_use_monorail_soa_endpoint';
import { FCM_DETAILS_SIGN_INTENT_VALID_SAMPLE_RATE } from './details/sign_intent_valid_sample_rate';
import { FCM_DETAILS_SIGN_USE_MONORAIL_SOA_ENDPOINT } from './details/sign_use_monorail_soa_endpoint';
import { FCM_DETAILS_SIGN_VALIDATION_ERROR_SAMPLE_RATE } from './details/sign_validation_error_sample_rate';
import { FCM_DETAILS_SIGNATURE_GROWTH_GOOGLE_ONE_TAP_LOGIN_CONFIG } from './details/signature_growth_google_one_tap_login_config';
import { FCM_DETAILS_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES } from './details/signature_growth_psf_fb_share_headlines';
import { FCM_DETAILS_SIGNATURE_GROWTH_PSF_WHATSAPP_SHARE_MESSAGE } from './details/signature_growth_psf_whatsapp_share_message';
import { FCM_DETAILS_SIGNATURE_THERMOMETER } from './details/signature_thermometer';
import { FCM_DETAILS_SIGNATURES_DISTRIBUTION_CONFIG } from './details/signatures_distribution_config';
import { FCM_DETAILS_STARFISH_CONDITIONAL_KICKSTART } from './details/starfish_conditional_kickstart';
import { FCM_DETAILS_STARFISH_HOMEPAGE_TO_SAP_DRAFT_V1 } from './details/starfish_homepage_to_sap_draft_v1';
import { FCM_DETAILS_STARFISH_HOMEPAGE_V2 } from './details/starfish_homepage_v2';
import { FCM_DETAILS_STARFISH_HOMEPAGE_V2_CONTENT } from './details/starfish_homepage_v2_content';
import { FCM_DETAILS_STARFISH_MULTIPLE_QRCODE_FLYERS } from './details/starfish_multiple_qrcode_flyers';
import { FCM_DETAILS_STARFISH_PETITION_KICKSTART_TOGGLE } from './details/starfish_petition_kickstart_toggle';
import { FCM_DETAILS_STARFISH_PETITION_QUALITY_SCORE_TOGGLE } from './details/starfish_petition_quality_score_toggle';
import { FCM_DETAILS_STARFISH_PSF_TO_SAP_LOCAL_FLOW } from './details/starfish_psf_to_sap_local_flow';
import { FCM_DETAILS_STARFISH_SALP_PERSONAL_STORY_TOGGLE } from './details/starfish_salp_personal_story_toggle';
import { FCM_DETAILS_STARFISH_SAP3_RECOMMENDED_ANGLES } from './details/starfish_sap3_recommended_angles';
import { FCM_DETAILS_STARFISH_SAP_VERSION_3 } from './details/starfish_sap_version_3';
import { FCM_DETAILS_STARFISH_SHARE_VISUALS } from './details/starfish_share_visuals';
import { FCM_DETAILS_STARFISH_STARTER_DASHBOARD_SIGNATURE_SOURCES } from './details/starfish_starter_dashboard_signature_sources';
import { FCM_DETAILS_STARFISH_STARTER_DM_RECOMMENDER } from './details/starfish_starter_dm_recommender';
import { FCM_DETAILS_STARTER_DASHBOARD_CONTACT_DM } from './details/starter_dashboard_contact_dm';
import { FCM_DETAILS_STARTER_DASHBOARD_DECISION_MAKERS_LIST_ENABLED } from './details/starter_dashboard_decision_makers_list_enabled';
import { FCM_DETAILS_STARTER_DASHBOARD_NEW_ASSETS } from './details/starter_dashboard_new_assets';
import { FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_PHASE4 } from './details/starter_experience_dashboard_phase4';
import { FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_READY_TO_SHARE_FCM } from './details/starter_experience_dashboard_ready_to_share_fcm';
import { FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_SUNRISE } from './details/starter_experience_dashboard_sunrise';
import { FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_TABS } from './details/starter_experience_dashboard_tabs';
import { FCM_DETAILS_STARTER_EXPERIENCE_NEXT_STEPS } from './details/starter_experience_next_steps';
import { FCM_DETAILS_STARTER_EXPERIENCE_PETITION_ACTIVITY } from './details/starter_experience_petition_activity';
import { FCM_DETAILS_STARTER_EXPERIENCE_READY_TO_SHARE_PREDRAFTED } from './details/starter_experience_ready_to_share_predrafted';
import { FCM_DETAILS_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS } from './details/starter_experience_share_recommendations';
import { FCM_DETAILS_STARTER_ONBOARDING_SUNRISE_TOGGLE } from './details/starter_onboarding_sunrise_toggle';
import { FCM_DETAILS_STARTER_SAP_AI_PROMPT } from './details/starter_sap_ai_prompt';
import { FCM_DETAILS_STARTER_SAP_PHONE_COLLECTION } from './details/starter_sap_phone_collection';
import { FCM_DETAILS_SUBSCRIPTION_CONFIGURATION } from './details/subscription_configuration';
import { FCM_DETAILS_SUBSCRIPTION_COUNTRY_STAFF_COUNT } from './details/subscription_country_staff_count';
import { FCM_DETAILS_SUNRISE_FOUNDATIONS_EXPERIENCE } from './details/sunrise_foundations_experience';
import { FCM_DETAILS_SUPPORTER_GROWTH_PSF_RECOMMENDED_GROUPS_EXPERIMENT } from './details/supporter_growth_psf_recommended_groups_experiment';
import { FCM_DETAILS_SUPPORTER_GROWTH_PSF_SHARE_ASSETS_EXPERIMENT } from './details/supporter_growth_psf_share_assets_experiment';
import { FCM_DETAILS_SUPPORTER_SHARE_VISUALS } from './details/supporter_share_visuals';
import { FCM_DETAILS_SUPPORTER_TO_STARTER_RECOMMENDATIONS_CONFIG } from './details/supporter_to_starter_recommendations_config';
import { FCM_DETAILS_SUPPORTER_TO_STARTER_RECOMMENDATIONS_ENABLED } from './details/supporter_to_starter_recommendations_enabled';
import { FCM_DETAILS_SUPPORTER_VOICES_DETAILS_PAGE } from './details/supporter_voices_details_page';
import { FCM_DETAILS_TOPIC_CLASSIFIER_SERVICE_AUTO_TRIGGER_ENABLED } from './details/topic_classifier_service_auto_trigger_enabled';
import { FCM_DETAILS_TOPIC_CLASSIFIER_SERVICE_AUTO_WRITE_ENABLED } from './details/topic_classifier_service_auto_write_enabled';
import { FCM_DETAILS_TOS_LEGAL_NOTICE_BANNER } from './details/tos_legal_notice_banner';
import { FCM_DETAILS_TOS_LEGAL_NOTICE_BANNER_COPY } from './details/tos_legal_notice_banner_copy';
import { FCM_DETAILS_TRANSACTION_FEE_UPSELL_CONFIGURATION } from './details/transaction_fee_upsell_configuration';
import { FCM_DETAILS_USE_DONATION_LANGUAGE } from './details/use_donation_language';
import { FCM_DETAILS_USE_MEMBERSHIP_DONATION_LANGUAGE } from './details/use_membership_donation_language';
import type { FcmDetails, FcmDetailsMap } from './shared/types';

export const FCM_DETAILS: FcmDetailsMap = {
	...FCM_DETAILS_ADVOCATES_PSF,
	...FCM_DETAILS_ADVOCATES_PSF_END_REDIRECT,
	...FCM_DETAILS_ADVOCATES_PSF_TASKS,
	...FCM_DETAILS_AI_SHARE_HEADLINE_BANDIT,
	...FCM_DETAILS_ALLOW_IDENTIFIED_USER_FETCH_PETITION_LISTS,
	...FCM_DETAILS_AMPLITUDE_SESSION_REPLAY_CONFIG,
	...FCM_DETAILS_AUTO_FREE_PROMOTIONS_ROLLOUT,
	...FCM_DETAILS_BETA_LOCALES_ENABLED,
	...FCM_DETAILS_BLOCKED_SIGNATURE_EXPORT,
	...FCM_DETAILS_CAMPAIGN_ACTIONS_PAGE_CONFIG,
	...FCM_DETAILS_CAMPAIGN_SUPPORTER_VOICES_SETTINGS,
	...FCM_DETAILS_CAPYBARA_HOMEPAGE_V3,
	...FCM_DETAILS_CAPYBARA_IMPACT_STORY,
	...FCM_DETAILS_CAROUSEL_CONFIGURATION,
	...FCM_DETAILS_CAROUSEL_MEMBERSHIP_CONFIGURATION,
	...FCM_DETAILS_COFFEE_GEO_PROFILE_QUALITY,
	...FCM_DETAILS_COMBO_PROMOTER_CONTRIBUTION_IMPACT_VALUES,
	...FCM_DETAILS_COMMS_STACK_DM_ADDED_ENGAGEMENT_VALUE_PROPS_ENABLED,
	...FCM_DETAILS_COMMS_STACK_PETITION_SIGNER_REENGAGEMENT_RECOMMENDATIONS_ENABLED,
	...FCM_DETAILS_COMMS_STACK_SUBJECT_LINE_EXPERIMENTATION_ENABLED,
	...FCM_DETAILS_COMMS_STACK_TEMPLATE_EXPERIMENTATION_ENABLED,
	...FCM_DETAILS_CONTEXTUAL_PROMOTION_BUTTONS_BANDIT_CONFIG,
	...FCM_DETAILS_CORAL_COMMENT_LIKE_EMAIL_ENABLED,
	...FCM_DETAILS_CORGI_ALLOW_IFRAME_EMBEDDING,
	...FCM_DETAILS_CORGI_OAUTH_MIGRATION_CONFIG,
	...FCM_DETAILS_CORGI_PERIMETERX_SENSOR_SCRIPT_ENABLED,
	...FCM_DETAILS_CORGI_REQUEST_PROVIDER_LOGGING_CONFIG,
	...FCM_DETAILS_CORGI_SSR_CACHE,
	...FCM_DETAILS_CORGI_SSR_CACHE_BUSTER,
	...FCM_DETAILS_CORGI_SSR_CACHE_LIFETIME_SECONDS_OVERRIDE,
	...FCM_DETAILS_CORGI_SSR_TIMINGS_RESPONSE_HEADER,
	...FCM_DETAILS_CORGI_USE_ASSETS_DOMAIN_FOR_SCRIPTS,
	...FCM_DETAILS_COUNTRY_BANNER,
	...FCM_DETAILS_CREAM_CHIP_IN_VALUES,
	...FCM_DETAILS_CREAM_PETITION_UPDATE_PROMOTION_ASK,
	...FCM_DETAILS_DATA_DISABLE_PETSVC_SALESFORCE_WORKER,
	...FCM_DETAILS_DECISION_MAKERS_AUTOADD_ENABLED,
	...FCM_DETAILS_DECISION_MAKERS_LEGISLATIVE_BODIES,
	...FCM_DETAILS_DISABLE_ADMIN_LOGIN,
	...FCM_DETAILS_DISABLE_GEOLOCATION_GUEST_SIGN_FORM,
	...FCM_DETAILS_DM_ABOUT_PAGE,
	...FCM_DETAILS_DM_PROFILE_REDESIGN,
	...FCM_DETAILS_DM_PROFILE_RESPONSIVENESS_SCORE_CONFIG,
	...FCM_DETAILS_DM_PROFILE_RESPONSIVENESS_SCORE_DATA,
	...FCM_DETAILS_DM_WITH_LEGISLATIVE_BODIES_CONNECTION_ENABLED,
	...FCM_DETAILS_DMI_SERVICE_AUTO_TRIGGER_ENABLED,
	...FCM_DETAILS_DOUBLE_OPT_IN_ENABLED,
	...FCM_DETAILS_DOUBLE_OPT_IN_PETITION_LIST,
	...FCM_DETAILS_DOUBLE_OPTIN_ENABLED_NEW_USER,
	...FCM_DETAILS_ENABLE_ADVOCATES_IDENTIFIED_EXPERIMENT,
	...FCM_DETAILS_ENABLE_BLACK_HISTORY_LOGO,
	...FCM_DETAILS_ENABLE_FOLKSONOMY_TOPICS,
	...FCM_DETAILS_ENABLE_PETITION_STRENGTH_TIPS,
	...FCM_DETAILS_ENABLE_PRIDE_LOGO,
	...FCM_DETAILS_ENABLE_SUBSCRIPTIONS_FOR,
	...FCM_DETAILS_ENABLE_VISION_FE_HELLOWORLD,
	...FCM_DETAILS_ENFORCE_SECURE_IDENTIFIED_STATE,
	...FCM_DETAILS_ENGAGEMENT_SIGN_FORM_MOBILE_OPT_IN_CONFIG,
	...FCM_DETAILS_EXPORT_SERVICE,
	...FCM_DETAILS_EXPORT_SIGNATURE_BLOCKLIST,
	...FCM_DETAILS_FUTURE_SAP_MARKETING_CONSENT_REQUIRED,
	...FCM_DETAILS_FUTURE_SAP_MEDIA_DISCLAIMER,
	...FCM_DETAILS_GATEWAY_ROUTER_STRIPE_CREATE_CHARGE_CONFIG,
	...FCM_DETAILS_GATEWAY_ROUTER_STRIPE_CREATE_OR_UPDATE_CUSTOMER_CONFIG,
	...FCM_DETAILS_GDPR_SIGN_OPT_IN,
	...FCM_DETAILS_GDPR_SIGN_OPT_IN_COPY,
	...FCM_DETAILS_GLOBAL_SHARE_BUTTON_CONFIG,
	...FCM_DETAILS_GOOGLE_AUTH,
	...FCM_DETAILS_GOOGLE_AUTH_USE_IDENTITY_SERVICES,
	...FCM_DETAILS_GRAPHQL_RESOLVER_TRACING,
	...FCM_DETAILS_GROWTH_BONUS_IMPRESSION_VALUE_UI,
	...FCM_DETAILS_GROWTH_IS_STARTER,
	...FCM_DETAILS_GROWTH_LEGAL_DISCLAIMER_UPDATE,
	...FCM_DETAILS_GROWTH_MEMBERSHIP_ROUTING_UPDATE,
	...FCM_DETAILS_GROWTH_MEMBERSHIP_UI_UPDATE,
	...FCM_DETAILS_HIDE_NAV_SAP_BUTTON_PER_PAGE,
	...FCM_DETAILS_HIDE_SIGNEES,
	...FCM_DETAILS_HIGH_AMOUNT_CONFIRMATION_MODAL,
	...FCM_DETAILS_HOMEPAGE_NOTICE,
	...FCM_DETAILS_HOMEPAGE_SUPPORT_AWARENESS,
	...FCM_DETAILS_LCM_PETITION_SIGNER_RECEIPT_WELCOME_CONFIG,
	...FCM_DETAILS_MAINTENANCE_BANNER,
	...FCM_DETAILS_MANUALLY_PROMOTED_PETITION_DATA,
	...FCM_DETAILS_MEMBER_PHONE_COLLECTION,
	...FCM_DETAILS_MEMBERSHIP_ANNUAL_CONTRIBUTION,
	...FCM_DETAILS_MEMBERSHIP_BOTTOM_BANNER_ENABLED_FOR,
	...FCM_DETAILS_MEMBERSHIP_CONTACT_EMAIL,
	...FCM_DETAILS_MEMBERSHIP_PPMU_ENABLED_FOR,
	...FCM_DETAILS_MEMBERSHIP_PPMU_OFFSITE_COPY,
	...FCM_DETAILS_MEMBERSHIP_PPMU_OFFSITE_LINK,
	...FCM_DETAILS_MIDDLE_END_RESTRICT_CLIENTS,
	...FCM_DETAILS_MOBILE_APP_DOWNLOAD_BOTTOM_BANNER_ENABLED,
	...FCM_DETAILS_MOBILE_APP_RELEASES,
	...FCM_DETAILS_MOBILE_APP_SMART_BANNER_CONFIG,
	...FCM_DETAILS_MOBILE_NOTIFICATIONS_CONFIG,
	...FCM_DETAILS_MONETIZATION_BANDIT_COMBO_EXP,
	...FCM_DETAILS_MOVEMENT_PETITION_ADD_NOTIFICATION,
	...FCM_DETAILS_NAFTA_PSF_SHARE_COPY_BANDIT_TRAFFIC_CONFIG,
	...FCM_DETAILS_NEW_PETITION_PAGE_ACCESS_EXPERIMENT,
	...FCM_DETAILS_NEW_PETITION_PAGE_GOOGLE_ADDRESS_EXPERIMENT,
	...FCM_DETAILS_NEW_PETITION_PAGE_REMOVE_RFS_EXPERIMENT,
	...FCM_DETAILS_NEWRELIC_BROWSER_ENABLED,
	...FCM_DETAILS_OCTOPUS_AA_AUGMENTED_SIGN_ASK_CONFIG,
	...FCM_DETAILS_OCTOPUS_AA_SIGN_ASK_CONFIG,
	...FCM_DETAILS_OCTOPUS_AUTO_AA_ML_DIGEST_CONFIG,
	...FCM_DETAILS_OCTOPUS_AUTO_AA_ML_DIGEST_NEW_ONBOARDING_CONFIG,
	...FCM_DETAILS_OCTOPUS_AUTO_AA_ML_SINGLE_CONFIG,
	...FCM_DETAILS_OCTOPUS_PETITION_SIGNER_RECEIPT_CONFIG,
	...FCM_DETAILS_OCTOPUS_PETITION_UPDATE_CONFIG,
	...FCM_DETAILS_OCTOPUS_TAKO_EDITOR_CONFIG,
	...FCM_DETAILS_OPTIMIZELY_ENABLED,
	...FCM_DETAILS_OPTIMIZELY_EVENT_SAFELIST,
	...FCM_DETAILS_OPTIMIZELY_PAGES,
	...FCM_DETAILS_OPTIMIZELY_PROPERTY_SAFELIST,
	...FCM_DETAILS_PACIFIC_DISABLE_COMMS_AA_EDITORIAL_RECENT_STARTER_SUPRESSION,
	...FCM_DETAILS_PACIFIC_PETITION_PROMOTION_CONFIG,
	...FCM_DETAILS_PACIFIC_PROMO_FREE_SAMPLE,
	...FCM_DETAILS_PAYMENT_METHODS_ENABLED_FOR,
	...FCM_DETAILS_PAYMENTS_SAVE_PAYMENT_CHECKMARK_CONFIG,
	...FCM_DETAILS_PAYPAL_MOBILE_DEFAULT,
	...FCM_DETAILS_PETITION_PAGE_CONTACT_DM,
	...FCM_DETAILS_PETITION_PAGE_DM_CONSTITUENCY_CONFIG,
	...FCM_DETAILS_PETITION_PAGE_FULL_SUNRISE,
	...FCM_DETAILS_PETITION_PAGE_NEWLY_CREATED_PETITIONS,
	...FCM_DETAILS_PETITION_PROMOTE_PAGE_FOR_COUNTRY,
	...FCM_DETAILS_PETITION_STARTER_MEDIA_INQUIRY,
	...FCM_DETAILS_PETITION_UPDATE_EMAIL_PREVIEW_ENABLED,
	...FCM_DETAILS_PETITIONS_WITH_BLOCKED_SIGNATURE_EXPORT,
	...FCM_DETAILS_PLATFORM_FRAUD_EMAIL_DOMAINS,
	...FCM_DETAILS_PRIVACY_ANONYMOUS_USERS,
	...FCM_DETAILS_PRIVACY_HIDE_RECRUITER,
	...FCM_DETAILS_PROMOTE_FORM_LAYOUT_EXPERIMENT,
	...FCM_DETAILS_PROMOTED_FULFILLMENT_BY_CHANNEL,
	...FCM_DETAILS_PROMOTED_PETITION_SIGNER_RECEIPT_DIGEST_EMAIL_PROMOTION_COUNT,
	...FCM_DETAILS_PROMOTED_PETITION_SIGNER_RECEIPT_WELCOME_EMAIL_PROMOTION_COUNT,
	...FCM_DETAILS_PROMOTED_PETITION_UPDATE_EMAIL_PROMOTION_SETTINGS,
	...FCM_DETAILS_PROMOTED_PETITIONS_DISABLE_USER_SIGNATURE_FETCH,
	...FCM_DETAILS_PROMOTED_PETITIONS_IN_FOOTER_WELL,
	...FCM_DETAILS_PROMOTED_PETITIONS_USE_UNFILTERED_LIST,
	...FCM_DETAILS_PROMOTED_SIGNATURE_RECEIPT_EMAIL_PROMOTION_COUNT,
	...FCM_DETAILS_PROMOTION_COUNTRY_GRADUAL_OPENING,
	...FCM_DETAILS_PROMOTIONS_ENDPOINT_CACHE_PETITION_STATS,
	...FCM_DETAILS_PROMOTIONS_INELIGIBLE_PETITION_REFUND_LIMIT,
	...FCM_DETAILS_PROMOTIONS_INELIGIBLE_PETITION_REFUNDS_ENABLED,
	...FCM_DETAILS_PROMOTIONS_SHOW_ALL_PROMOTIONS_AT_START_OF_CAROUSEL,
	...FCM_DETAILS_PSF_CONTEXTUAL_BANDITS_ENABLED,
	...FCM_DETAILS_PSF_PROMOTE_OR_SHARE_SHARE_SLIDE_UP_ENABLED,
	...FCM_DETAILS_PSF_REASON_FOR_SIGNING,
	...FCM_DETAILS_PSF_SHARE_BUTTON_CONFIG,
	...FCM_DETAILS_PSF_SHARE_INITIAL_ABOVE_BUTTON_MESSAGE,
	...FCM_DETAILS_PSF_SHARE_MESSAGE_BUTTON_ORDER,
	...FCM_DETAILS_REGISTERED_VOTERS_CONFIG,
	...FCM_DETAILS_REVENUE_BANDITS_PSF_COMBO_EXPERIMENT,
	...FCM_DETAILS_REVENUE_DYNAMIC_CPM,
	...FCM_DETAILS_REVENUE_LOCALIZED_MEMBERSHIP_ASK_HEADLINE,
	...FCM_DETAILS_REVENUE_PETITION_AI_SUMMARIES_COMBO_EXPERIMENT,
	...FCM_DETAILS_REVENUE_PETITION_AI_SUMMARIES_ENABLED,
	...FCM_DETAILS_REVENUE_PPMU_SUNRISE_DOUBLE_HOLDOUT_EXPERIMENT,
	...FCM_DETAILS_REVENUE_SUBS_ONE_TIME_CONTRIBUTIONS,
	...FCM_DETAILS_REVENUE_VICTORIOUS_PETITION_PROMOTION_ENABLED,
	...FCM_DETAILS_SAP_AI_IMAGE_PROMPT,
	...FCM_DETAILS_SAP_CTA_ON_PETITION_SHOW,
	...FCM_DETAILS_SEARCH_V2_MAINTENANCE,
	...FCM_DETAILS_SHOW_SAVE_PAYMENT_CHECKBOX_CONFIG,
	...FCM_DETAILS_SIGN_CONFIRM_USE_MONORAIL_SOA_ENDPOINT,
	...FCM_DETAILS_SIGN_INTENT_VALID_SAMPLE_RATE,
	...FCM_DETAILS_SIGN_USE_MONORAIL_SOA_ENDPOINT,
	...FCM_DETAILS_SIGN_VALIDATION_ERROR_SAMPLE_RATE,
	...FCM_DETAILS_SIGNATURE_GROWTH_GOOGLE_ONE_TAP_LOGIN_CONFIG,
	...FCM_DETAILS_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES,
	...FCM_DETAILS_SIGNATURE_GROWTH_PSF_WHATSAPP_SHARE_MESSAGE,
	...FCM_DETAILS_SIGNATURE_THERMOMETER,
	...FCM_DETAILS_SIGNATURES_DISTRIBUTION_CONFIG,
	...FCM_DETAILS_STARFISH_CONDITIONAL_KICKSTART,
	...FCM_DETAILS_STARFISH_HOMEPAGE_TO_SAP_DRAFT_V1,
	...FCM_DETAILS_STARFISH_HOMEPAGE_V2,
	...FCM_DETAILS_STARFISH_HOMEPAGE_V2_CONTENT,
	...FCM_DETAILS_STARFISH_MULTIPLE_QRCODE_FLYERS,
	...FCM_DETAILS_STARFISH_PETITION_KICKSTART_TOGGLE,
	...FCM_DETAILS_STARFISH_PETITION_QUALITY_SCORE_TOGGLE,
	...FCM_DETAILS_STARFISH_PSF_TO_SAP_LOCAL_FLOW,
	...FCM_DETAILS_STARFISH_SALP_PERSONAL_STORY_TOGGLE,
	...FCM_DETAILS_STARFISH_SAP3_RECOMMENDED_ANGLES,
	...FCM_DETAILS_STARFISH_SAP_VERSION_3,
	...FCM_DETAILS_STARFISH_SHARE_VISUALS,
	...FCM_DETAILS_STARFISH_STARTER_DASHBOARD_SIGNATURE_SOURCES,
	...FCM_DETAILS_STARFISH_STARTER_DM_RECOMMENDER,
	...FCM_DETAILS_STARTER_DASHBOARD_CONTACT_DM,
	...FCM_DETAILS_STARTER_DASHBOARD_DECISION_MAKERS_LIST_ENABLED,
	...FCM_DETAILS_STARTER_DASHBOARD_NEW_ASSETS,
	...FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_PHASE4,
	...FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_READY_TO_SHARE_FCM,
	...FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_SUNRISE,
	...FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_TABS,
	...FCM_DETAILS_STARTER_EXPERIENCE_NEXT_STEPS,
	...FCM_DETAILS_STARTER_EXPERIENCE_PETITION_ACTIVITY,
	...FCM_DETAILS_STARTER_EXPERIENCE_READY_TO_SHARE_PREDRAFTED,
	...FCM_DETAILS_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS,
	...FCM_DETAILS_STARTER_ONBOARDING_SUNRISE_TOGGLE,
	...FCM_DETAILS_STARTER_SAP_AI_PROMPT,
	...FCM_DETAILS_STARTER_SAP_PHONE_COLLECTION,
	...FCM_DETAILS_SUBSCRIPTION_CONFIGURATION,
	...FCM_DETAILS_SUBSCRIPTION_COUNTRY_STAFF_COUNT,
	...FCM_DETAILS_SUNRISE_FOUNDATIONS_EXPERIENCE,
	...FCM_DETAILS_SUPPORTER_GROWTH_PSF_RECOMMENDED_GROUPS_EXPERIMENT,
	...FCM_DETAILS_SUPPORTER_GROWTH_PSF_SHARE_ASSETS_EXPERIMENT,
	...FCM_DETAILS_SUPPORTER_SHARE_VISUALS,
	...FCM_DETAILS_SUPPORTER_TO_STARTER_RECOMMENDATIONS_CONFIG,
	...FCM_DETAILS_SUPPORTER_TO_STARTER_RECOMMENDATIONS_ENABLED,
	...FCM_DETAILS_SUPPORTER_VOICES_DETAILS_PAGE,
	...FCM_DETAILS_TOPIC_CLASSIFIER_SERVICE_AUTO_TRIGGER_ENABLED,
	...FCM_DETAILS_TOPIC_CLASSIFIER_SERVICE_AUTO_WRITE_ENABLED,
	...FCM_DETAILS_TOS_LEGAL_NOTICE_BANNER,
	...FCM_DETAILS_TOS_LEGAL_NOTICE_BANNER_COPY,
	...FCM_DETAILS_TRANSACTION_FEE_UPSELL_CONFIGURATION,
	...FCM_DETAILS_USE_DONATION_LANGUAGE,
	...FCM_DETAILS_USE_MEMBERSHIP_DONATION_LANGUAGE,
};

export type { FcmDetails };
